import React from 'react';
import { Shield } from 'lucide-react';

// 1. Estilos Globais (Animações e remoção de barra de rolagem)
export const GlobalStyles = () => (
  <style>{`
    .no-scrollbar::-webkit-scrollbar { display: none; }
    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    
    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-fade-up { animation: fadeUp 0.6s ease-out forwards; }

    /* Splash de entrada do app — logo "aparece com peso", igual apps de
       banco/loja: começa pequeno e opaco, cresce com uma leve sobra
       elástica (overshoot) até o tamanho final. */
    @keyframes splashLogoPop {
      0% { opacity: 0; transform: scale(0.75); }
      60% { opacity: 1; transform: scale(1.04); }
      100% { opacity: 1; transform: scale(1); }
    }
    .animate-splash-logo { animation: splashLogoPop 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }

    /* O escudo É o indicador de carregamento — "respira" (pulsa) em loop
       enquanto a splash está na tela, em vez de uma barra de progresso
       separada. */
    @keyframes splashShieldBreathe {
      0%, 100% { transform: scale(1); filter: drop-shadow(0 0 15px rgba(190,242,100,0.3)); }
      50% { transform: scale(1.08); filter: drop-shadow(0 0 30px rgba(190,242,100,0.6)); }
    }
    .animate-splash-shield { animation: splashShieldBreathe 1.4s ease-in-out infinite; }
  `}</style>
);

// 2. Fundo "Dark Fintech" com Auras Volumétricas
export const CyberBackground = ({ isMobileView }) => (
  // Mudamos de "fixed" para "absolute" para o brilho ficar preso DENTRO do app
  <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden bg-[#010208]">
    {/* Glow Verde Neon (Topo Esquerda) */}
    <div className="absolute top-[-10%] left-[-20%] w-[70%] h-[50%] rounded-full bg-lime-400/5 blur-[120px]"></div>
    {/* Glow Roxo Corporate (Fundo Direita) */}
    <div className="absolute bottom-[-10%] right-[-20%] w-[60%] h-[60%] rounded-full bg-purple-600/10 blur-[150px]"></div>
  </div>
);

// 3. Ícone do Escudo Central com Brilho
export const IconShieldBig = ({ className = '', size = 80 }) => (
  <div className={`relative flex items-center justify-center ${className}`}>
    <div className="absolute inset-0 bg-lime-400/20 blur-[30px] rounded-full"></div>
    <Shield size={size} className="text-lime-400 relative z-10" strokeWidth={1.5} />
  </div>
);